// ----------------------------------------------------------------------

const breakpoints = {
  values: {
    xs: 0,
    dg: 500,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    laptop: 1024,
  }
};

export default breakpoints;
